module.exports = __webpack_public_path__ + "img/course_cover.8e165f48.png";